moduleViewApp.service("ModulePermissionsHelper", ['$rootScope', 'SiteNavigationService', 'myPartnersService', ($rootScope, SiteNavigationService, myPartnersService) ->
  $scope = $rootScope.$new()

  window.debug = window.debug || {}
  window.debug["ModulePermissionsHelper"] = $scope

  _.assignIn $scope,
    canEditModuleInParentContext: (module) ->
      parentId = parseInt(myPartnersService.currentProductPartner?.relationships?.parent?.data?.id)
      return parentId == parseInt(module.partner_id)

    canEditModuleInPartnerContext: (module) ->
      if module.partner_id
        # Partner module
        if parseInt(myPartnersService.currentProductPartner?.id) == parseInt(module.partner_id)
          if myPartnersService.currentProductPartner.meta["can-manage-content"]
            # Everyone else gets permission from the partner
            true
          else if myPartnersService.currentProductPartner.meta["can-edit-content"]
            # Editors defer to the set for their permissions
            module.permissions?.editable
          else
            false
        else
          # We might be able to edit this set, but we're in the wrong context
          false
      else
        # Personal set
        module.permissions?.editable      

  $scope
])
